import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as lodash from 'lodash';

if (environment.production) {
  enableProdMode();
}

// declare global {
//   const _: typeof lodash;
// }

// (window as any)['_'] = lodash;
// (globalThis as any)['_'] = lodash;

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
